module.exports = __webpack_public_path__ + "static/media/hydroId.fa059ade.png";